/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { NodeModel } from '@minoru/react-dnd-treeview'

type Props = {
	node: NodeModel
	depth: number
}

export const Placeholder: React.FC<Props> = props => {
	return (
		<View css={style} style={{ left: props.depth * 24 }} data-testid="placeholder"></View>
	)
}

const style = css({
	backgroundColor: '#1967d2',
	width: '100%',
	height: '2px',
	position: 'absolute',
	right: 0,
	transform: 'translateY(-50%)',
	top: 0,
})
